import React from "react";
import {Helmet} from "react-helmet";
import PropTypes from "prop-types";


export default class MetaHeader extends React.Component {
	static propTypes = {
		description: PropTypes.string.isRequired
	}

	constructor(props) {
		super(props);
	}

	render() {
		return (
			<Helmet>
				<meta name="description" content={this.props.description}/>
			</Helmet>
		)
	}
}
